export enum ScenarioType {
  None = 'None',
  Bed = 'Bed',
  Room = 'Room',
  Video = 'Video',
  Audio = 'Audio',
  CurrentLocation = 'CurrentLocation',
  Acoustic = 'Acoustic',
  Door = 'Door',
  Intruder = 'Intruder',
  Bathroom = 'Bathroom',
  FallDetection = 'FallDetection',
  WanderingDetection = 'WanderingDetection',
  Absence = 'Absence',
  Visitor = 'Visitor',
}
